/**
 * Knopf in der Kopfleiste neben „Ansicht ▾" (Rafael, 03.10.2026): hell, dunkel oder
 * automatisch wie das Geraet. Reihum ☀ → ☾ → Auto. Gilt sofort, wird pro Geraet gemerkt
 * (lib/farbschema.ts). Der Knopf zeigt die GEWAEHLTE Stellung.
 */
import { NAECHSTE_WAHL, setzeFarbschema, useFarbschemaWahl, type FarbschemaWahl } from '../lib/farbschema';

const ZEICHEN: Record<FarbschemaWahl, string> = { hell: '☀', dunkel: '☾', auto: '◐ A' };
const NAME: Record<FarbschemaWahl, string> = { hell: 'Hell', dunkel: 'Dunkel', auto: 'Automatisch (wie das Gerät)' };

export default function TagNachtSchalter() {
  const { wahl, schema } = useFarbschemaWahl();
  const naechste = NAECHSTE_WAHL[wahl];
  const jetzt = wahl === 'auto' ? `${NAME.auto} — gerade ${schema === 'hell' ? 'hell' : 'dunkel'}` : NAME[wahl];
  const titel = `${jetzt}. Klick: ${NAME[naechste]}`;
  return <button type="button" className="cui-ansicht-knopf cui-tag-nacht" data-ai-id="cui-tag-nacht"
    data-wahl={wahl} aria-label={titel} title={titel}
    onClick={() => setzeFarbschema(naechste)}>
    {ZEICHEN[wahl]}
  </button>;
}
